<div class="container cl-form" [id]="formId" [formGroup]="poFormGroup">
  @if (airlines().length == 1) {
    <input type="hidden" formControlName="airline" [value]="airlines()[0].iata_code">
  }
  <!-- The PO header: the IFE form's flat field grid. A default (outlined) card, as on the IFE form:
       the page's cl-section-alternate is Haze already, so a Haze card would not show. -->
  @if (airlines().length > 0) {
    <div class="row cl-spacing-small">
      <div class="col-12">
        <div class="card" data-po-header>
          <div class="card-header">Purchase order</div>
          <div class="card-body">
            <!-- The format is fixed on this page, so its description stands where the IFE form shows it
                 under the format select. -->
            @if (templateDescription) {
              <p class="cl-spacing-none" data-template-description>{{ templateDescription }}</p>
            }
            <h3 [class.cl-spacing-none]="!templateDescription">Project information</h3>
            <div class="row">
              @if (airlines().length > 1) {
                <div class="col-12 col-md-4">
                  <label [for]="formId + '-airlines'" class="form-label">Airlines</label>
                  <select [id]="formId + '-airlines'" class="form-select" [class.invalid]="poFormGroup.controls.airline.errors?.required && (poFormGroup.controls.airline.touched || submitted)" formControlName="airline">
                    <option [value]="null" disabled selected>[None selected yet]</option>
                    @for (airline of airlines(); track airline) {
                      <option [value]="airline.iata_code"> {{ airline.airline_name }}
                        ({{ airline.iata_code }})
                      </option>
                    }
                  </select>
                  @if (poFormGroup.controls.airline.errors?.required && (poFormGroup.controls.airline.touched || submitted)) {
                    <p class="invalid-feedback">This field is required.</p>
                  }
                  @if (!poFormGroup.controls.airline.errors || (!poFormGroup.controls.airline.touched && !submitted)) {
                    <p class="valid-feedback">Specifies the customer for whom this encode is performed.</p>
                  }
                </div>
              }
              <div class="col-12" [class.col-md-8]="airlines().length > 1">
                <label [for]="formId + '-projectid'" class="form-label">Project ID<span class="required">*</span></label>
                <input [id]="formId + '-projectid'" [class.invalid]="poFormGroup.controls.po_number.invalid && (poFormGroup.controls.po_number.touched || submitted)" type="text" formControlName="po_number" pattern="[A-Za-z0-9_\.\-\/]+">
                @if (poFormGroup.controls.po_number.errors?.required) {
                  <p class="invalid-feedback">This field is required.</p>
                }
                @if (poFormGroup.controls.po_number.errors?.pattern) {
                  <p class="invalid-feedback">Only letters, numbers and '_', '-', '/' or '.' are allowed</p>
                }
                @if (poFormGroup.controls.po_number.errors?.poNameTooLong; as tooLong) {
                  <p class="invalid-feedback">The PO name "{{ tooLong.poName }}" has {{ tooLong.actual }}
                    characters; the encoder accepts at most {{ tooLong.max }}.</p>
                }
                @if (poFormGroup.controls.po_number.errors?.s3TagValueTooLong; as tooLong) {
                  <p class="invalid-feedback">The PO name is too long: it encodes to {{ tooLong.encoded }} of at
                    most {{ tooLong.max }} characters. Characters outside <code>A-Z a-z 0-9 + - = . _ :</code>
                    need three characters each when encoded.</p>
                }
                @if (!poFormGroup.controls.po_number.errors) {
                  <p class="valid-feedback">The Project ID groups related encodes for easier reference and organization.</p>
                }
              </div>
            </div>

            <hr class="cl-spacing-medium">
            <h3 class="cl-spacing-medium">Delivery settings</h3>
            <div class="row">
              <div class="col-12 col-md-4">
                <label [for]="formId + '-po_destination'" class="form-label">Delivery destination<span class="required">*</span></label>
                <select [id]="formId + '-po_destination'" class="form-select" [class.invalid]="poFormGroup.controls.po_destination.errors?.required && (poFormGroup.controls.po_destination.touched || submitted)" formControlName="po_destination"
                  [compareWith]="compare_destination_id">
                  <option [value]="null" disabled selected>[None selected yet]</option>
                  @for (sys of poDestinations; track sys) {
                    <option [value]="sys.destination_id">{{ sys.display_name }}</option>
                  }
                </select>
                @if (poFormGroup.controls.po_destination.errors?.required && (poFormGroup.controls.po_destination.touched || submitted)) {
                  <p class="invalid-feedback">This field is required.</p>
                }
                @if (!poFormGroup.controls.po_destination.errors || (!poFormGroup.controls.po_destination.touched && !submitted)) {
                  <p class="valid-feedback">Select the desired destination.</p>
                }
              </div>
              <div class="col-12 col-md-4">
                <label [for]="formId + '-auto_publish'" class="form-label">Publication</label>
                <select [id]="formId + '-auto_publish'" class="form-select" formControlName="auto_publish">
                  <option [ngValue]="true"> Automatic
                  </option>
                  <option [ngValue]="false"> Manual
                  </option>
                </select>
                @if (poFormGroup.get('auto_publish')?.value === true) {
                  <p class="valid-feedback">Content is distributed immediately when encoding completes.</p>
                } @else {
                  <p class="valid-feedback">Content requires QA approval before distribution.</p>
                }
              </div>
              <div class="col-12 col-md-4">
                <label [for]="formId + '-email_notification'" class="form-label">Email Notification</label>
                <input [id]="formId + '-email_notification'" type="text" formControlName="email_notification"
                       [class.invalid]="poFormGroup.controls.email_notification.invalid && (poFormGroup.controls.email_notification.touched || poFormGroup.controls.email_notification.dirty || submitted)">
                @if (poFormGroup.controls.email_notification.errors?.email) {
                  <p class="invalid-feedback">Please insert a valid email.</p>
                }
                @if (!poFormGroup.controls.email_notification.errors) {
                  <p class="valid-feedback">Notified about success or failure of the workflow. Leave blank to skip notifications.</p>
                }
              </div>
            </div>

            <!-- Output options are PO level even though VTK reads them per encode: every item of a PO is
                 delivered together, so they share one watermark, one encryption setting and one ladder --
                 and the DRM tier boundaries the ladder carries are effectively global anyway. Submit copies
                 all of it into each item's format_specific_data. Rendered from the template's
                 format_specific_data schema (template_capabilities) inside this card, as on the IFE form: a
                 section per group after a ruler, advanced fields behind one switch. -->
            <app-schema-format-specific formControlName="format_specific_data" [schema]="fsdSchema"
                                        [revealErrors]="submitted" [sourceDurationSeconds]="poSourceDurationSeconds"
                                        [ruleBefore]="true" [sections]="sections" [fieldHints]="fieldHints"
                                        idPrefix="vod" (edited)="settingsEdited = true"></app-schema-format-specific>
          </div>
        </div>
      </div>
    </div>
  }

  @if (poItems.controls.length > 0) {
    <div class="row cl-spacing-large">
      <div class="col-12">
        <h2>PO Items</h2>
        <p>Review and adjust the encode settings for each item below - you can update the Encode ID and configure options such as watermark, encryption, and thumbnail generation. When ready, press "Start encode" to submit.</p>
      </div>
    </div>
  }
  <ng-container formArrayName="poItems">
    @for (item of poItems.controls ; track poItemTrackBy(idx, item); let idx = $index) {
      <ng-container [formGroup]="poItems.controls[idx]" [formGroupName]="idx">
        <!-- One collapsible card per PO item, open when added, as in the IFE form. Its sections are
             h3 headings in the body, not inner cards: cards don't nest. -->
        <div class="row cl-spacing-small">
          <div class="col-12">
            <details class="card" open data-po-item [id]="formId + '-item-' + idx"
                     [class.cl-color-red-outline]="submitted && poItems.controls[idx].invalid">
              <summary class="card-header">
                @if (submitted && poItems.controls[idx].invalid) {
                  <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                }
                PO item {{ idx + 1 }}: {{ poItems.controls[idx].value['basics']['po_item_id'] }}
                <!-- preventDefault: a click on the button must not also toggle the card. -->
                <button class="cl-btn-quickaction" type="button"
                        (click)="$event.preventDefault(); poService.removePOItem(poItems.controls[idx].value['id'])">
                  Remove item
                </button>
              </summary>
              <div class="card-body">
                <input type="hidden" formControlName="id">
                <app-basic-poitem-vod-info formControlName="basics" layout="section" [submitted]="submitted"
                                           [idPrefix]="formId + '-' + idx + '-'"></app-basic-poitem-vod-info>
              </div>
            </details>
          </div>
        </div>
      </ng-container>
    }
  </ng-container>

  <!-- The shared form footer: tools first, then the message, then the one primary action. -->
  <div class="row cl-spacing-small">
    <div class="col-12">
      <!-- The output options are remembered in this browser and reused for the next PO; export them
           to share a ladder or keep a copy with the delivery. -->
      <p>Output options are remembered in this browser for your next PO.</p>
      <!-- The file picker itself is never shown: a bare file input carries the browser's own
           "No file chosen" label, which reads as a form field the operator has failed to fill
           in rather than as an action. -->
      <input #settingsFile (change)="importSettings($event)" accept="application/json,.json"
             hidden tabindex="-1" type="file">
      <app-message-field #settingsMessages></app-message-field>
      <app-form-footer [label]="startEncodeLabel(poItems.controls.length)" icon="play" (action)="submit_po($event)">
        <button footerStart (click)="exportSettings()" class="btn cl-color-tertiary" type="button">
          Export settings
        </button>
        <button footerStart (click)="settingsFile.click()" class="btn cl-color-tertiary" type="button">
          Import settings
        </button>
        @if (hasStoredSettings) {
          <button footerStart (click)="resetSettings()" class="btn cl-color-tertiary" type="button">
            Forget settings
          </button>
        }
      </app-form-footer>
    </div>
  </div>
</div>
